import Tween from "tween.ts";
import Animation from "./Animation";
import SoundButton from "../entities/buttons/SoundButton";

export default class SoundButtonAnimation extends Animation {
  constructor(SoundButton: SoundButton,scaleX:number, onComp: () => void) {
    super();
    new Tween.Tween(SoundButton.scale)
      .to({ x: scaleX}, 300)
      .easing(Tween.Easing.Exponential.Out)
      .onComplete(() => onComp())
      .start()
  }
}